module.exports = __webpack_public_path__ + "static/movantik-naloxegol-desktop-a9b08223e5cff33805ea71a3dafd4d0b.png";